import { Component } from '@angular/core';

@Component({
  selector: 'app-hand-money-simple-icon',
  templateUrl: './hand-money-simple-icon.component.html',
  styles: [
  ]
})
export class HandMoneySimpleIconComponent {

}
